<template>
  <v-card flat>
    <v-card flat>
      <v-card-title>Campaigns</v-card-title>
      <v-card-text>
        <v-data-table v-model="selectedCampaign" :headers="campaignColumns" :items="campaigns" item-key="campaign_id"
          :loading="isLoading" :single-select="singleSelect" show-select>
          <template v-slot:item.campaign_name="{ item }">
            {{ item.campaign_name || 'R3 Campaign' }}
          </template>

        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title>Mail Events {{ filterCampaignId ? `[Campaign ${filterCampaignId}]` : '' }}</v-card-title>
      <v-card-text>
        <v-data-table :headers="mailEventColumns" :items="mailEvents" item-key="id" :loading="isLoading">
          <template v-slot:item.event_time="{ item }">
            {{ item.event_time | toDateTime }}
          </template>
          <template v-slot:item.message="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="d-inline-block text-truncate" style="max-width: 400px;">
                  {{ item.message }}
                </span>
              </template>
              <span>{{ item.message }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { MailEventsApi } from '@/services'
import * as R from 'ramda'

export default {
  name: 'customer-mail-events',
  props: {
    // value == customer_id
    value: {
      type: [Array],
      default: function () { return [] }
    },
    showLoading: {
      required: false,
      type: Boolean
    }
  },
  components: {
  },
  data: function () {
    return {
      loading: false,
      singleSelect: true,
      mailEventData: [],
      campaignColumns: [
        { text: 'Campaign Name', value: 'campaign_name' },
        { text: 'Campaign ID', value: 'campaign_id' },
        { text: 'Dealer Name', value: 'sender_name' }
      ],
      selectedCampaign: [],

      //  %w(id event event_source email account_id sender_name sender_id campaign_name campaign_id
      //    campaign_run_id message event_time)
      mailEventColumns: [
        { text: 'Email', value: 'email' },
        { text: 'Event', value: 'event' },
        { text: 'Event Time', value: 'event_time' },
        { text: 'Message', value: 'message' },
        { text: 'Campaign ID', value: 'campaign_id' },
        { text: 'Campaign Run ID', value: 'campaign_run_id' },
        { text: 'Targeted Vin', value: 'targeted_vin' }
      ]
    }
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' }),
    isLoading: function () {
      return this.showLoading || this.loading
    },
    campaigns: function () {
      const campaigns = new Set(this.mailEventData.map(med => med.campaign_id))
      return Array.from(campaigns).map(cid => R.find(R.propEq('campaign_id', cid))(this.mailEventData))
    },
    mailEvents: function () {
      let filter = R.always(true)
      if (this.filterCampaignId) {
        filter = R.propEq('campaign_id', this.filterCampaignId)
      }
      return R.filter(filter, this.mailEventData)
    },
    filterCampaignId: function () {
      return (this.selectedCampaign[0] || {}).campaign_id
    }
  },
  watch: {
    value(newVal) {
      this.mailEventData = []
      this.selectedCampaign = []
      if (newVal && newVal.length > 0) {
        this.loadMailEvents(newVal)
      }
    }
  },
  methods: {
    loadMailEvents(emails) {
      this.$logger.trace('Fetching Mail Events')
      this.loading = true
      MailEventsApi.fetchMailEvents(this.dealer.id, emails, 'customer_events_by_email')
        .then(results => {
          this.mailEventData = results.data
          this.loading = false
        })
        .catch(error => {
          this.$logger.error('Unable to load mail events', error.message)
          this.loading = false
          this.$flash({
            showClose: true,
            message: 'Unable to load mail events. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    }
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.loadMailEvents(this.value)
    }
  }
}
</script>

<style></style>
